import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebars from '../../components/sidebars/Sidebars'
import Header from '../../components/header/Header'
import deleteLogo from "../../assets/delete-1.png";
import viewLogo from "../../assets/view-1.png";
import editLogo from "../../assets/edit-1.png";
import Footer from '../../components/footer/Footer';
import { useGetFaqQuery, useDeleteFaqMutation } from '../../Services/FaqApi';
import EditFaq from './editFaq/EditFaq';
import DeleteFaq from './deleteFaq/DeleteFaq';
import { toast } from "react-toastify";
import LoadingAction from '../../components/Loader';
import ReactPaginate from 'react-paginate';

const Faq = () => {
    const navigate = useNavigate();
   
    const [faqs, setFaqs] = useState([' ']);
    const [deleteFaq] = useDeleteFaqMutation();
    const [editShowModal, setEditShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [faqId, setFaqId] = useState('')
    const [showLoader, setShowLoader] = useState(false);
const [search, setSearch] = useState('')
const [page, setPage] = useState(0);
   const [pageSize, setPageSize] = useState(10);
   const [totalPageCount, setTotalPageCount] = useState(0);
    const { data: faqRetrive, refetch } = useGetFaqQuery({ search, limit: pageSize, page: page + 1 });
    const addQuestionHandler = () => {
        navigate('/add-faq')
    }
    useEffect(() => {
        console.log(faqRetrive)
        setFaqs(faqRetrive?.data?.faqs)
         setTotalPageCount(faqRetrive?.data?.pagination?.totalPages)
    }, [faqRetrive])
    const handleClose = () => {
        setEditShowModal(false);
        setShowDeleteModal(false)
    };
    const editFaqHandler = (e, id) => {
        e.preventDefault();
        console.log(id)
        setEditShowModal(true);
        setFaqId(id);
    }
    const deleteFaqHandler = (e, id) => {
        e.preventDefault();
        setShowDeleteModal(true);
        setFaqId(id);

    }
    const handleDeleteFaq = () => {
        setShowLoader(true)
        deleteFaq(faqId)
            .unwrap()
            .then((res) => {
                toast.success(res?.message);
                setShowLoader(false)
                setFaqs(
                    faqs.filter((customer) => customer?.id !== faqId)
                );
                refetch();
            })
            .catch((err) => {
                setShowLoader(false)
                toast.error(err?.data?.message);
            });
    };

    const handlePageClick = (event) => {
      setPage(event.selected)

   };

    const refetchFaq = () => {
        refetch();
    }

       useEffect(() => {
          const delayDebounce = setTimeout(() => {
             refetch();
          }, 500);
    
          return () => clearTimeout(delayDebounce);
       }, [search, page]);

    return (
        <>
            <Sidebars />
            <Header />
            <main id="main" className="main mt-0 h-100 min-vh-80">
                <div class="pagetitle">
                    <div className="d-flex justify-content-between align-items-center mb-3 mobile-block">
                        <div className="d-flex gap-4 mobile-block">

                            <div className="div">
                                <h1>FAQs</h1>
                                <nav>
                                    <ol class="breadcrumb mb-0">
                                        <li class="breadcrumb-item"><a href="">Home</a></li>
                                        
                                    </ol>
                                </nav>
                            </div>


                            <div class="search-bar mt-1">
                                <form class="d-flex" role="search">
                                    <div class="border-rounded-15 border-0">
                                        <div className="input-group">
                                            <input type="text" className="form-control border-0 bg-none" placeholder="Search..." 
                                            value={search}
                                          onChange={(e) => setSearch(e.target.value)}
                                            />
                                            <span className="input-group-text bg-none border-0">
                                                <i className="b- bi-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>



                        <div class="">
                        <button className="btn btn-main me-2" onClick={addQuestionHandler}><i className="bi bi-plus-lg me-2"></i>Add Questions</button>
                        </div>
                    </div>
                </div>
                {editShowModal && (<EditFaq editShowModal={editShowModal} handleClose={handleClose} faqId={faqId} refetchFaq={refetchFaq} />)}
                {showDeleteModal && (<DeleteFaq showDeleteModal={showDeleteModal} handleClose={handleClose} handleDelete={handleDeleteFaq} />)}
                <div className="container-fluid mt-2 pt-2">
                    <div className="row">
                        <div className="col-md-12 px-0">
                            {showLoader && <LoadingAction />}

                            <div className="clearfix mb-4 mt-2">
                                <div className="float-start">
                            <h6 className="text-color fw-bolder mb-0">FAQs Lists</h6>

                                    
                                </div>
                               
                            </div>

                            <div className="card border-0 table-card">
                                <div className="card-body">

                                    <div className="table-responsive">
                                        <table className="table table-striped mb-0 align-middle common-table ">
                                            <thead>
                                                <tr>
                                                    <th scope="col">S no.</th>
                                                    <th scope="col">Question</th>
                                                    <th scope="col">Answer</th>
                                                    {/* <th scope="col">Status</th> */}
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {faqs?.map((faq, index) => (
                                                    <tr key={faq.id}>
                                                        <th scope="row">{index + 1}</th>
                                                        <td>{faq.question}</td>
                                                        <td>{faq?.answer?.substring(0, 30) + '...'}</td>
                                                        <td>
                                                            {/* Add buttons for actions */}
                                                           
                                                <button className="btn btn-edit me-2 action-wh" onClick={(e) => editFaqHandler(e, faq?._id)}><img src={editLogo} alt="image" className="img-fluid action-image" /></button>
                                                            <button className="btn btn-delete  me-2 action-wh" onClick={(e) => deleteFaqHandler(e, faq?._id)}><img src={deleteLogo} alt="image" className="img-fluid action-image" /></button>
                                                        </td>
                                                    </tr>
                                                ))}


                                            </tbody>
                                        </table>
                                    </div>
                                    {faqs?.length > 0 &&
                                                                  <ReactPaginate
                                                                     breakLabel="..."
                                                                     breakClassName={'break'}
                                                                     nextLabel=" >"
                                                                     containerClassName={"pagination"}
                                                                     activeClassName={"active"}
                                                                     onPageChange={handlePageClick}
                                                                     forcePage={page}
                                                                     pageRangeDisplayed={5}
                                                                     marginPagesDisplayed={1}
                                                                     pageCount={totalPageCount}
                                                                     previousLabel="< "
                                                                     renderOnZeroPageCount={null}
                                                                  />
                                                               }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
            <Footer />
        </>
    )
}

export default Faq